<div class="container-fluid p-3 container-custom" style="margin-bottom : 40px;">
    <div class="card">
        <div class="card-header header" style="">
            <h1>Sleep Education</h1>

        </div>  
         <div class="card-body">	
		 
            <div class="row p-3" style="padding-left : 40px; padding-right : 40px;">
                <div class="col mobile_slider" *ngFor="let tile of mobile_observed" [colspan]="tile.cols" [rowspan]="tile.rows">
                    <mat-card class="educate-card" (click)="currentLesson(tile.index)" [ngClass]="{'disable-card': (tile.index > this.maxStep + 1)}" tabindex="-1">
                        <!-- <img mat-card-image src={{tile.img}}> -->
                        <!-- <div *ngIf="currentPage == title.index">
                        checked
                        </div> -->
                        <div height="20px"
                            style='padding-top:6px; padding-left:6px;border-radius:16px 16px 0px 0px;background-position:center;height:170px;background-size:cover;background: url("{{tile.img}}")'>
                            <!-- <div *ngIf="currentPage == tile.index"> -->
                        


                            <!-- </div> -->
                        </div>
                        <mat-card-content>
                          <div class="row">
                            <div class="col-md-9">
                            <p class="title-text" style="color : #012233;">
                                <b>{{tile.text}}</b>
                            </p>
                            </div>
                            <div class="col-md-3">
								                                <svg width="22" height="22" viewBox="0 0 31 31" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M15.1668 3.76456C8.48132 3.76456 3.06168 9.18421 3.06168 15.8697C3.06168 22.5551 8.48132 27.9748 15.1668 27.9748C21.8523 27.9748 27.2719 22.5551 27.2719 15.8697C27.2719 9.18421 21.8523 3.76456 15.1668 3.76456ZM0.0354004 15.8697C0.0354004 7.51284 6.80996 0.738281 15.1668 0.738281C23.5236 0.738281 30.2982 7.51284 30.2982 15.8697C30.2982 24.2265 23.5236 31.0011 15.1668 31.0011C6.80996 31.0011 0.0354004 24.2265 0.0354004 15.8697ZM22.2246 10.9559C22.8492 11.5111 22.9055 12.4675 22.3503 13.0921L14.2802 22.1709C13.9931 22.494 13.5815 22.6788 13.1493 22.6788C12.7171 22.6788 12.3055 22.494 12.0183 22.1709L7.9833 17.6315C7.42811 17.0069 7.48436 16.0505 8.10896 15.4953C8.73356 14.9401 9.68997 14.9964 10.2452 15.621L13.1493 18.8881L20.0884 11.0816C20.6436 10.457 21.6 10.4007 22.2246 10.9559Z"
                                        [attr.fill]="selectedActionPlanList.includes(tile.index) ? '#27ca40' : '#979797'" />
                                </svg>
                            </div>
                           </div>
                        </mat-card-content>

                    </mat-card>
                </div>
            </div>
			
            <div class="row p-3" style="padding-left : 40px; padding-right : 40px;">
                <div class="col screen_slider" *ngFor="let tile of observed" [colspan]="tile.cols" [rowspan]="tile.rows">
                    <mat-card class="educate-card" (click)="currentLesson(tile.index)" [ngClass]="{'disable-card': (tile.index > this.maxStep + 1)}" tabindex="-1">
                        <!-- <img mat-card-image src={{tile.img}}> -->
                        <!-- <div *ngIf="currentPage == title.index">
                        checked
                        </div> -->
                        <div height="20px"
                            style='padding-top:6px; padding-left:6px;border-radius:16px 16px 0px 0px;background-position:center;height:170px;background-size:cover;background: url("{{tile.img}}")'>
                            <!-- <div *ngIf="currentPage == tile.index"> -->
                        


                            <!-- </div> -->
                        </div>
                        <mat-card-content>
                          <div class="row">
                            <div class="col-md-9">
                            <p class="title-text" style="color : #012233;">
                                <b>{{tile.text}}</b>
                            </p>
                            </div>
                            <div class="col-md-3">
								                                <svg width="22" height="22" viewBox="0 0 31 31" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M15.1668 3.76456C8.48132 3.76456 3.06168 9.18421 3.06168 15.8697C3.06168 22.5551 8.48132 27.9748 15.1668 27.9748C21.8523 27.9748 27.2719 22.5551 27.2719 15.8697C27.2719 9.18421 21.8523 3.76456 15.1668 3.76456ZM0.0354004 15.8697C0.0354004 7.51284 6.80996 0.738281 15.1668 0.738281C23.5236 0.738281 30.2982 7.51284 30.2982 15.8697C30.2982 24.2265 23.5236 31.0011 15.1668 31.0011C6.80996 31.0011 0.0354004 24.2265 0.0354004 15.8697ZM22.2246 10.9559C22.8492 11.5111 22.9055 12.4675 22.3503 13.0921L14.2802 22.1709C13.9931 22.494 13.5815 22.6788 13.1493 22.6788C12.7171 22.6788 12.3055 22.494 12.0183 22.1709L7.9833 17.6315C7.42811 17.0069 7.48436 16.0505 8.10896 15.4953C8.73356 14.9401 9.68997 14.9964 10.2452 15.621L13.1493 18.8881L20.0884 11.0816C20.6436 10.457 21.6 10.4007 22.2246 10.9559Z"
                                        [attr.fill]="selectedActionPlanList.includes(tile.index) ? '#27ca40' : '#979797'" />
                                </svg>
                            </div>
                           </div>
                        </mat-card-content>

                    </mat-card>
                </div>
            </div>   
    <!-- 
    <p *ngIf="currentPage == 0">1</p>
    <p *ngIf="currentPage == 1">2</p>
    <p *ngIf="currentPage == 2">3</p>
    <p *ngIf="currentPage == 3">4</p>
    <p *ngIf="currentPage == 4">5</p>
    <p *ngIf="currentPage == 5">6</p>
    <p *ngIf="currentPage == 6">7</p>
    <p *ngIf="currentPage == 7">8</p> -->

<div class="row" style="padding-top : 20px; padding-bottom : 20px;">
   <div class="col-md-5">
    <mat-progress-bar class="card-progress progress_screen" mode="determinate" [value]="observedmin*33.33">
    </mat-progress-bar>
   </div>
   <div class="col-md-3"></div>
   <div class="col-md-4">
       <div class="row step_screen">
	    <div class="col-md-6">
        <a><p style="color : #002E46; font-size : 18px;" (click)="changePage(-1)"><span><img src="/assets/icons/Vector-Left.png" /></span><b>Previous</b></p></a>
        </div>
		<div class="col-md-6">
        <a><p style="color : #002E46; font-size : 18px;" (click)="changePage(1)"><b>Next</b><span><img src="/assets/icons/Vector-Right.png" /></span></p></a>
        </div>
		</div>
       <div class="row step_mobile">
	    <div class="col-md-6">
        <a><p style="color : #002E46; font-size : 18px;" (click)="changePage_mobile(-1)"><span><img src="/assets/icons/Vector-Left.png" /></span><b>Previous</b></p></a>
        </div>
		<div class="col-md-6">
        <a><p style="color : #002E46; font-size : 18px;" (click)="changePage_mobile(1)"><b>Next</b><span><img src="/assets/icons/Vector-Right.png" /></span></p></a>
        </div>
		</div>
	</div>
</div>


<div class="row">
    <ng-container *ngIf="currentPage == 5">
        <sleep-1>
		</sleep-1>
    </ng-container>
    <ng-container *ngIf="currentPage == 6">
        <educate-intro></educate-intro>
    </ng-container>

    <ng-container *ngIf="currentPage == 7">
        <educate-1>

        </educate-1>
    </ng-container>
    <ng-container *ngIf="currentPage == 8">
        <educate-2>

        </educate-2>
    </ng-container>
    <ng-container *ngIf="currentPage == 9">
        <educate-3>

        </educate-3>
    </ng-container>
    <ng-container *ngIf="currentPage == 10">
        <educate-4>

        </educate-4>
    </ng-container>
    <ng-container *ngIf="currentPage == 11">
        <educate-5>

        </educate-5>
    </ng-container>
    <ng-container *ngIf="currentPage ==12">
        <educate-6>

        </educate-6>
    </ng-container>
</div>

</div>
</div>

</div>